import React, { useState } from 'react'
import { Modal } from 'react-bootstrap'
// import { TiTick } from 'react-icons/ti'
import { Link } from 'react-router-dom'
import LoadingSpinner from '../Movie/Loading'
import Readmorewords from '../Movie/Readmorewords'

export default function CollectionDisplayTable(props) {
  const {
    loadSpinner,
    listMovieCollections,
    status,
    ApproveOptionBoolean,
    ApproveCollection,
    deleteFunction,
    nextToken,
    loadMore,
    from,
    loadMoreSearch,
    checkedArray,
    setCheckedArray,
    EDitOptionPermission,
    DeleteOptionPermission,
  } = props
  const [showPopup, setshowPopup] = useState(false)
  const [itemDel, setItemDel] = useState({})
  const [itemIndex, setItemIndex] = useState('')
  const ApproveDelete = () => {
    deleteFunction(itemDel, itemIndex)
    setItemDel({})
    setItemIndex('')
    setshowPopup(false)
  }

  const checkedArrayChange = (event, value) => {
    const checkedArrayTemp = [...checkedArray]
    if (event.target.checked) {
      checkedArrayTemp.push(value)
      setCheckedArray(checkedArrayTemp)
    } else {
      const checkedremoved = checkedArrayTemp.filter(e => e.SK !== value.SK)
      setCheckedArray(checkedremoved)
    }
  }

  return (
    <div>
      {loadSpinner && <LoadingSpinner />}
      {listMovieCollections && listMovieCollections.length !== 0 && (
        <table className='tableclassName sticky-thc' style={{ width: '100%' }}>
          <tr
            style={{
              backgroundColor: 'lightgray',
              zIndex: '1',
              position: 'relative',
              border: '1px solid black',
            }}
          >
            <th className='tdclassName' style={{ padding: '10px' }}>
              SN
            </th>
            <th className='tdclassName' style={{ padding: '10px' }}>
              Actions
            </th>
            <th className='tdclassName' style={{ padding: '10px' }}>
              checkbox
            </th>
            <th className='tdclassName' style={{ padding: '10px' }}>
              PK
            </th>
            <th className='tdclassName' style={{ padding: '10px' }}>
              SK
            </th>
            <th className='tdclassName' style={{ padding: '10px' }}>
              title_En
            </th>
            <th className='tdclassName' style={{ padding: '10px' }}>
              title_Te
            </th>
            <th className='tdclassName' style={{ padding: '10px' }}>
              description_En
            </th>
            <th className='tdclassName' style={{ padding: '10px' }}>
              description_Te
            </th>
            <th className='tdclassName' style={{ padding: '10px' }}>
              createdByHandle
            </th>
            <th className='tdclassName' style={{ padding: '10px' }}>
              createdByID
            </th>
            <th className='tdclassName' style={{ padding: '10px' }}>
              movieCollectionCreatedDate
            </th>
            <th className='tdclassName' style={{ padding: '10px' }}>
              movieCollectionCreatedTime
            </th>
            <th className='tdclassName' style={{ padding: '10px' }}>
              movieCollectionUpdatedTime
            </th>
            <th className='tdclassName' style={{ padding: '10px' }}>
              movieCollectionUpdatedDate
            </th>
            <th className='tdclassName' style={{ padding: '10px' }}>
              movieCollectionID
            </th>
            <th className='tdclassName' style={{ padding: '10px' }}>
              updatedByHandle
            </th>
            <th className='tdclassName' style={{ padding: '10px' }}>
              updatedByID
            </th>
          </tr>
          {listMovieCollections.map((item, index) => (
            <tr key={index} style={{ textAlign: 'center' }}>
              <td className='tdclassName' style={{ padding: '10px' }}>
                {index + 1}
              </td>
              <td className='tdclassName' style={{ minWidth: '100px' }}>
                <div
                  style={{
                    minWidth: '100px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  {status === 'draft' && ApproveOptionBoolean && (
                    <button
                      style={{ borderRadius: '8px', marginRight: '4px' }}
                      type='button'
                      onClick={() => ApproveCollection(item, index)}
                    >
                      <i className='fas fa-upload'></i>
                    </button>
                  )}
                  {DeleteOptionPermission && <button
                    style={{ borderRadius: '8px', marginRight: '4px' }}
                    type='button'
                    onClick={() => {
                      setshowPopup(true)
                      setItemDel(item)
                      setItemIndex(index)
                      // deleteFunction(item, index)
                    }}
                  >
                    <i className='fas fa-trash fa-lg'></i>
                    <div className='popup'></div>
                  </button>}
                  {EDitOptionPermission && <Link
                    data-toggle='tooltip'
                    title={'Edit Movie Collection'}
                    to={`/editmoviecollection?${item.SK.replace('#', '$')}`}
                    target='_blank'
                  >
                    <button style={{ borderRadius: '8px' }} type='button'>
                      <i className='fas fa-pencil-alt fa-lg' />
                    </button>
                  </Link>}
                </div>
              </td>
              <td className='tdclassName' style={{ padding: '10px' }}>
                <input
                  checked={Boolean(checkedArray.some(x => x.SK === item.SK))}
                  type='checkbox'
                  onChange={event => {
                    checkedArrayChange(event, item)
                  }}
                />
              </td>
              <td className='tdclassName' style={{ padding: '10px' }}>
                <div>{item.PK}</div>
              </td>
              <td className='tdclassName' style={{ padding: '10px' }}>
                <div>{item.SK}</div>
              </td>
              <td className='tdclassName' style={{ padding: '10px' }}>
                <div>{item.title_En}</div>
              </td>
              <td className='tdclassName' style={{ padding: '10px' }}>
                <div>{item.title_Te}</div>
              </td>
              <td className='tdclassName' style={{ padding: '10px' }}>
                <div>
                  <Readmorewords>{item.description_En}</Readmorewords>{' '}
                </div>
              </td>
              <td className='tdclassName' style={{ padding: '10px' }}>
                <div>
                  <Readmorewords>{item.description_Te}</Readmorewords>
                </div>
              </td>
              <td className='tdclassName' style={{ padding: '10px' }}>
                <div>{item.createdByHandle}</div>
              </td>
              <td className='tdclassName' style={{ padding: '10px' }}>
                <div>{item.createdByID}</div>
              </td>
              <td className='tdclassName' style={{ padding: '10px' }}>
                <div>{item.movieCollectionCreatedDate}</div>
              </td>
              <td className='tdclassName' style={{ padding: '10px' }}>
                <div>{item.movieCollectionCreatedTime}</div>
              </td>
              <td className='tdclassName' style={{ padding: '10px' }}>
                <div>{item.movieCollectionUpdatedTime}</div>
              </td>
              <td className='tdclassName' style={{ padding: '10px' }}>
                <div>{item.movieCollectionUpdatedDate}</div>
              </td>
              <td className='tdclassName' style={{ padding: '10px' }}>
                <div>{item.movieCollectionID}</div>
              </td>
              <td className='tdclassName' style={{ padding: '10px' }}>
                <div>{item.updatedByHandle}</div>
              </td>
              <td className='tdclassName' style={{ padding: '10px' }}>
                <div>{item.updatedByID}</div>
              </td>
            </tr>
          ))}
        </table>
      )}
      {listMovieCollections && listMovieCollections.length === 0 && <p>No Data Found</p>}
      {nextToken && (
        <button onClick={loadMore} className='btn btn-primary m-2'>
          loadMore..
        </button>
      )}
      {from && listMovieCollections.length > 9 && (
        <button onClick={loadMoreSearch} className='btn btn-primary m-2'>
          loadMore..
        </button>
      )}
      <Modal
        show={showPopup}
        dialogClassName='modal-90w'
        // fullscreen={'md-down'}
        onHide={() => {
          setItemDel({})
          setItemDel('')
          setshowPopup(false)
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you Sure You Want to Delete it</Modal.Body>
        <Modal.Footer>
          <button
            type='button'
            className='btn btn-primary'
            onClick={() => {
              setItemDel({})
              setItemDel('')
              setshowPopup(false)
            }}
          >
            Cancel
          </button>
          <button type='button' className='btn btn-primary' onClick={() => ApproveDelete()}>
            OK
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}
